export type EventCategory =
  | 'Nightlife'
  | 'Brunch'
  | 'Sports'
  | 'Special'
  | 'Industry'

export interface VenueEvent {
  id: number
  date: string // short, e.g. "JAN 23"
  fullDate: string // "Friday, January 23, 2026"
  isoDate: string // "2026-01-23" for date filtering/sorting
  title: string
  artist: string
  time: string
  venue: string
  image: string
  /** Day of week label used as "Event Type" */
  type: string
  /** Higher-level grouping used as "Category" */
  category: EventCategory
}

export const events: VenueEvent[] = [
  {
    id: 1,
    date: 'JAN 23',
    fullDate: 'Friday, January 23, 2026',
    isoDate: '2026-01-23',
    title: 'AFTER HOURS',
    artist: 'NOMADIQ',
    time: '1AM',
    venue: 'Main Floor',
    image:
      'https://cdn.magicpatterns.com/uploads/rJSkXauUYeoLtet5juNndy/SnapInsta.to_681279189_18095297528328170_1432439404206680717_n.jpg',
    type: 'FRIDAY',
    category: 'Nightlife',
  },
  {
    id: 2,
    date: 'JAN 24',
    fullDate: 'Saturday, January 24, 2026',
    isoDate: '2026-01-24',
    title: 'AFTER HOURS',
    artist: 'DJ NINO',
    time: '1AM',
    venue: 'Main Floor',
    image:
      'https://images.unsplash.com/photo-1571266028243-371695039989?q=80&w=1000&auto=format&fit=crop',
    type: 'SATURDAY',
    category: 'Nightlife',
  },
  {
    id: 3,
    date: 'JAN 25',
    fullDate: 'Sunday, January 25, 2026',
    isoDate: '2026-01-25',
    title: 'INDUSTRY SUNDAY',
    artist: 'DJ KILOO',
    time: '1AM',
    venue: 'Rooftop',
    image:
      'https://images.unsplash.com/photo-1598387993441-a364f854c3e1?q=80&w=1000&auto=format&fit=crop',
    type: 'SUNDAY',
    category: 'Industry',
  },
  {
    id: 4,
    date: 'JAN 29',
    fullDate: 'Thursday, January 29, 2026',
    isoDate: '2026-01-29',
    title: "DRINK DANCE DRAI'S",
    artist: 'DJ MARX',
    time: '10PM',
    venue: 'Lounge',
    image:
      'https://cdn.magicpatterns.com/uploads/6T3H2WZmmtkMUMZCbd7Kxp/SnapInsta.to_681340710_18095297600328170_3727840379771406033_n.jpg',
    type: 'THURSDAY',
    category: 'Nightlife',
  },
  {
    id: 5,
    date: 'JAN 30',
    fullDate: 'Friday, January 30, 2026',
    isoDate: '2026-01-30',
    title: 'AFTER HOURS',
    artist: 'DJ POUN',
    time: '1AM',
    venue: 'Main Floor',
    image:
      'https://cdn.magicpatterns.com/uploads/at2R9HfHifzkaQFcUBJR5b/SnapInsta.to_660779906_18095297552328170_5827793037302573987_n.jpg',
    type: 'FRIDAY',
    category: 'Nightlife',
  },
  {
    id: 6,
    date: 'JAN 31',
    fullDate: 'Saturday, January 31, 2026',
    isoDate: '2026-01-31',
    title: 'AFTER HOURS',
    artist: 'DJ ROMEO',
    time: '1AM',
    venue: 'Main Floor',
    image:
      'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?q=80&w=1000&auto=format&fit=crop',
    type: 'SATURDAY',
    category: 'Nightlife',
  },
  {
    id: 7,
    date: 'FEB 1',
    fullDate: 'Sunday, February 1, 2026',
    isoDate: '2026-02-01',
    title: 'INDUSTRY SUNDAY',
    artist: 'GUEST DJ',
    time: '1AM',
    venue: 'Rooftop',
    image:
      'https://images.unsplash.com/photo-1514525253440-b393452e8d26?q=80&w=1000&auto=format&fit=crop',
    type: 'SUNDAY',
    category: 'Industry',
  },
  {
    id: 8,
    date: 'FEB 5',
    fullDate: 'Thursday, February 5, 2026',
    isoDate: '2026-02-05',
    title: 'LADIES NIGHT',
    artist: 'SPECIAL GUEST',
    time: '10PM',
    venue: 'Lounge',
    image:
      'https://images.unsplash.com/photo-1545128485-c400e7702796?q=80&w=1000&auto=format&fit=crop',
    type: 'THURSDAY',
    category: 'Special',
  },
  {
    id: 9,
    date: 'FEB 6',
    fullDate: 'Friday, February 6, 2026',
    isoDate: '2026-02-06',
    title: 'AFTER HOURS',
    artist: 'RESIDENT DJ',
    time: '1AM',
    venue: 'Main Floor',
    image:
      'https://images.unsplash.com/photo-1506157786151-b8491531f063?q=80&w=1000&auto=format&fit=crop',
    type: 'FRIDAY',
    category: 'Nightlife',
  },
  {
    id: 10,
    date: 'FEB 7',
    fullDate: 'Saturday, February 7, 2026',
    isoDate: '2026-02-07',
    title: 'AFTER HOURS',
    artist: 'RESIDENT DJ',
    time: '1AM',
    venue: 'Main Floor',
    image:
      'https://images.unsplash.com/photo-1516280440614-6697288d5d38?q=80&w=1000&auto=format&fit=crop',
    type: 'SATURDAY',
    category: 'Nightlife',
  },
  {
    id: 11,
    date: 'FEB 8',
    fullDate: 'Sunday, February 8, 2026',
    isoDate: '2026-02-08',
    title: 'BIG GAME',
    artist: 'WATCH PARTY',
    time: '2PM',
    venue: 'Sports Lounge',
    image:
      'https://images.unsplash.com/photo-1518609878373-06d740f60d8b?q=80&w=1000&auto=format&fit=crop',
    type: 'SUNDAY',
    category: 'Sports',
  },
]

export const EVENT_TYPES = ['THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'] as const

export const EVENT_CATEGORIES: EventCategory[] = [
  'Nightlife',
  'Industry',
  'Brunch',
  'Sports',
  'Special',
]
